/*! @pentacode/ui v0.1.0 */
import { t as e } from "../decorateMetadata-BhwOl-pv.js";
import { t } from "../decorate-DHgd5sZx.js";
import "lit";
import { property as n } from "lit/decorators.js";
//#region src/elements/formElement.ts
var r = (r) => {
	class i extends r {
		connectedCallback() {
			super.connectedCallback();
		}
		disconnectedCallback() {
			super.disconnectedCallback();
		}
		static {
			this.formAssociated = !0;
		}
		get formValue() {
			return this.value;
		}
		updated(e) {
			e.has("value") && this.internals.setFormValue(this.formValue), super.updated(e);
		}
		constructor(...e) {
			super(...e), this.value = null, this.internals = this.attachInternals();
		}
	}
	return t([n(), e("design:type", Object)], i.prototype, "value", void 0), i;
};
//#endregion
export { r as FormElement };

//# sourceMappingURL=formElement.js.map